import type { ReactNode } from 'react';
import { ScrollArea } from '@/components/ui/scroll-area';
import { cn } from '@/lib/utils';

/**
 * A ScrollArea that cannot be widened by its content. Radix gives the viewport's
 * inner wrapper `display: table`, which sizes to max-content, so one long string
 * stretches the column instead of ellipsing inside it; `!block` undoes that.
 * `enabled={false}` renders children bare, for callers that scroll a parent.
 */
export const ContainedScrollArea = ({
	children,
	className,
	enabled = true
}: {
	children: ReactNode;
	className?: string;
	enabled?: boolean;
}) => {
	if (!enabled) return <>{children}</>;
	return (
		<ScrollArea className={cn('min-h-0 flex-1 [&_[data-radix-scroll-area-viewport]>div]:!block', className)}>
			{children}
		</ScrollArea>
	);
};
